import React, { useState, useEffect, useRef } from 'react';
import img1 from '../assets/img/01.png';
import img2 from '../assets/img/02.png';
import img3 from '../assets/img/03.png';


function Carousel() {
  const slides = [img1, img2, img3, img1, img2];
  const [currentIndex, setCurrentIndex] = useState(1);
  const [lastDirection, setLastDirection] = useState('right');

  const centerSlideRef = useRef(null);

  const total = slides.length;
  const prevIndex = (currentIndex - 1 + total) % total;
  const nextIndex = (currentIndex + 1) % total;

  // force animation class toggle at DOM level
  useEffect(() => {
    const el = centerSlideRef.current;
    if (!el) return;

    const animClass = lastDirection === 'right' ? 'slide-left' : 'slide-right';

    // remove both animation classes first
    el.classList.remove('slide-left', 'slide-right');

    // force reflow → makes next add visible to browser
    void el.offsetWidth;

    // then add new animation class
    el.classList.add(animClass);
  }, [currentIndex, lastDirection]);

  const handlePrev = () => {
    setCurrentIndex((prev) => (prev - 1 + total) % total);
    setLastDirection('left');
  };

  const handleNext = () => {
    setCurrentIndex((prev) => (prev + 1) % total);
    setLastDirection('right');
  };

  return (
    <>
      <section className="text-center about-us">
        <h2 className="text-center" style={{ color: '#038ff7', marginBottom: '2%' }}>About Us</h2>
        <p>
        We are a next-generation creative content and post-production studio.
Our mission is simple, to craft world-class visual experiences that blend art, technology, and story. 
From emotionally-driven commercials to bold branded content,
HoB Studio creates visuals that move audiences and elevate brands.
We’re shaping the future of creative storytelling right here in the Balkans, with global ambition

        </p>
      </section>

      <section>
        <div className="carousel-wrapper">
          <button className="carousel-arrow left" onClick={handlePrev}>
            <i className="icon ion-chevron-left"></i>
          </button>

          <div className="carousel-track">
            <div className="carousel-slide">
              <img src={slides[prevIndex]} alt={`Slide ${prevIndex + 1}`} />
            </div>
            <div
              ref={centerSlideRef}
              className="carousel-slide center"
            >
              <img src={slides[currentIndex]} alt={`Slide ${currentIndex + 1}`} />
            </div>
            <div className="carousel-slide">
              <img src={slides[nextIndex]} alt={`Slide ${nextIndex + 1}`} />
            </div>
          </div>

          <button className="carousel-arrow right" onClick={handleNext}>
            <i className="icon ion-chevron-right"></i>
          </button>
        </div>
      </section>
    </>
  );
}

export default Carousel;
